import { apiFetch } from "@/lib/api";

export type AdditionalRequestService = {
  id: number;
  request_title: string;
  request_description?: string | null;
  request_price?: number | null;
  request_images?: string[] | null;
  created_by?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
};

export type AdditionalRequestServiceListItem = {
  id: number;
  request_title: string;
  request_price?: number | null;
  updated_at?: string | null;
};

export type AdditionalRequestServiceListResponse = {
  items: AdditionalRequestServiceListItem[];
  total: number;
};

export const fetchAdditionalRequestServices = async (params: {
  page: number;
  size: number;
  search?: string;
  sortField?: string | null;
  sortOrder?: string | null;
}): Promise<AdditionalRequestServiceListResponse> => {
  const query = new URLSearchParams();
  query.set("page", String(params.page));
  query.set("size", String(params.size));
  if (params.search) query.set("search", params.search);
  if (params.sortField) query.set("sortField", params.sortField);
  if (params.sortOrder) query.set("sortOrder", params.sortOrder);
  const payload = await apiFetch<AdditionalRequestServiceListResponse | null>(
    `/additional-request-services?${query.toString()}`
  );
  return payload ?? { items: [], total: 0 };
};

export const getAdditionalRequestService = async (id: number): Promise<AdditionalRequestService> => {
  return apiFetch<AdditionalRequestService>(`/additional-request-services/${id}`);
};

export const createAdditionalRequestService = async (
  data: Partial<AdditionalRequestService>
): Promise<AdditionalRequestService> => {
  return apiFetch<AdditionalRequestService>("/additional-request-services", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateAdditionalRequestService = async (
  id: number,
  data: Partial<AdditionalRequestService>
): Promise<AdditionalRequestService> => {
  return apiFetch<AdditionalRequestService>(`/additional-request-services/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteAdditionalRequestService = async (id: number): Promise<void> => {
  await apiFetch<void>(`/additional-request-services/${id}`, { method: "DELETE" });
};

export const deleteAllAdditionalRequestServices = async (): Promise<void> => {
  await apiFetch<void>("/additional-request-services", { method: "DELETE" });
};
